import { Input, Textarea } from '@heroui/react';
import { useCheckout } from '@features/checkout';

export const CourierDelivery = () => {
  const checkout = useCheckout();
  return (
    <>
      <div className="pb-4 flex flex-col gap-y-3">
        <p className="text-[#222223] pt-4 pb-1 font-semibold text-base">
          Покупатель
        </p>

        <Input
          isDisabled
          isRequired
          label="Город"
          value={checkout.data.city}
          size="lg"
        />

        <Input
          isRequired
          label="Улица"
          value={checkout.data.address}
          onValueChange={checkout.data.setAddress}
          size="lg"
        />

        <div className="grid grid-cols-3 gap-x-3">
          <Input
            isRequired
            label="Дом"
            value={checkout.data.build}
            onValueChange={checkout.data.setBuild}
            size="lg"
          />
          <Input
            isRequired
            label="Квартира"
            value={checkout.data.flat}
            onValueChange={checkout.data.setFlat}
            size="lg"
          />
          <Input
            label="Подъезд"
            value={checkout.data.entrance}
            onValueChange={checkout.data.setEntrance}
            size="lg"
          />
        </div>

        <Textarea
          label="Комментарий для курьера"
          value={checkout.data.comment}
          onValueChange={checkout.data.setComment}
          size="lg"
        />
      </div>
    </>
  );
};
